import {ActivatedRouteSnapshot} from "@angular/router";
import {RouteClaims} from "../dtos/routeClaims";
import {AuthenticatedOnlyGuard} from "../guards/authenticated-only.guard";
import {AuthService} from "../services/auth/auth.service";
import {ApproverOnlyGuard} from "../guards/approver-only.guard";
import {TermsOfUseGuard} from "@core/terms-of-use/guards/terms-of-use-guard";

export interface CanActivateResult {
	isAuthenticated: boolean;
	hasClaims: boolean;
}

export const canActivateRoute = (route: ActivatedRouteSnapshot, authService: AuthService): CanActivateResult => {
	const isAuthenticated = authService.isAuthenticated() || authService.canReauthenticated();
	if (!route || !route.data) {
		return {isAuthenticated, hasClaims: true};
	}
	return {isAuthenticated, hasClaims: verifyClaims(route, authService)};
}

export const verifyClaims = (route: ActivatedRouteSnapshot, authService: AuthService): boolean => {
	const result: boolean[] = [];
	const claims = route.data['claims'] as RouteClaims;
	if (claims) {
		Object.keys(claims).forEach(claimKey => {
			claims[claimKey].forEach((claimValue: string) => {
				result.push(authService.hasClaim(claimKey, claimValue));
			});

		});
	}
	return result.length == 0 || result.some(v => v === true);
}

export function canActivateWithPermission(claims: RouteClaims, animation: string | undefined = undefined) {
	return {
		data: {claims, animation},
		canActivate: [AuthenticatedOnlyGuard, TermsOfUseGuard],
		canActivateChild: [AuthenticatedOnlyGuard, TermsOfUseGuard]
	}
}

export function canActivateApproverRoutesWithPermissions(claims: RouteClaims) {
	return {data: {claims}, canActivate: [ApproverOnlyGuard]}
}
